export enum OcrReasonsToReject {
  REJECTED_OUTDATED_RECEIPT = 'Rejected - Outdated receipt',
  REJECTED_NON_RELATED_RECEIPT = 'Rejected - Non-related receipt',
  REJECTED_DUPLICATED_RECEIPT = 'Rejected - Duplicated receipt',
  REJECTED_INCOMPLETE_DETAILS = 'Rejected - Incomplete details',
  REJECTED_EXCEEDED_MONTHLY_SUBMISSION_LIMIT = 'Rejected - Exceeded Monthly Submission Limit (Max. 7 receipts per month)',
  REJECTED_MULTIPLE_RECEIPTS = "Rejected - More than 1 receipt",
}
